"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentFieldNameContext = exports.OnChangeContext = exports.ErrorMessagesContext = exports.ValueContext = void 0;
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const ValueContext = react_1.default.createContext({});
exports.ValueContext = ValueContext;
const ParentFieldNameContext = react_1.default.createContext(null);
exports.ParentFieldNameContext = ParentFieldNameContext;
const ErrorMessagesContext = react_1.default.createContext({});
exports.ErrorMessagesContext = ErrorMessagesContext;
const OnChangeContext = react_1.default.createContext((fieldName, fieldValue) => { });
exports.OnChangeContext = OnChangeContext;
//# sourceMappingURL=Contexts.js.map